import {
  Box,
  Heading,
  Menu,
  MenuButton,
  Button,
  MenuList,
  MenuItem,
  VStack,
} from "@chakra-ui/react";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

export const Invite = () => {
  const { t } = useTranslation();
  const shareUrl = window.location.href; // Get the current page URL for sharing

  return (
      <Box
          w={{ base: "100%", md: "30%" }}
          textAlign={{ base: "center", md: "left" }}
          bg="white" // Ensure the background is white
          p={4} // Add padding for better spacing
          borderRadius="10px" // Add rounded corners
          boxShadow="md" // Add a subtle shadow for depth
      >
        <Heading
            as="h3"
            fontSize="24px"
            mb="15px"
            textAlign="center"
            color="#111833" // Use a neutral color for the heading
        >
          {t("Invite Friends")}
        </Heading>
        <Box mt="20px">
          <Menu>
            <MenuButton
                as={Button}
                w="100%"
                p="15px"
                leftIcon={<FontAwesomeIcon icon={faUserPlus} />}
                borderRadius="10px"
                backgroundColor="#6AF6FF" // Brand color for button
                color="white"
                _hover={{ backgroundColor: "#5AE3E5" }} // Slightly darker shade on hover
            >
              {t("Invite Friends")}
            </MenuButton>
            <MenuList
                display="flex"
                flexDirection="column" // Stack items vertically
                justifyContent="center"
                alignItems="center"
                p={3}
                backgroundColor="white" // Ensure the background is white
                borderRadius="10px"
                boxShadow="md"
            >
              <VStack spacing={3}> {/* Use VStack for vertical alignment */}
                <MenuItem
                    minH="48px"
                    as="div"
                    bg="transparent"
                    p={0}
                    _hover={{ bg: "none" }}
                    display="flex"
                    justifyContent="center"
                >
                  <FacebookShareButton
                      url={shareUrl} // Use the current page URL
                      quote="Check out this event on Eventeam!" // Optional: Add a quote for Facebook
                  >
                    <FacebookIcon size={40} round />
                  </FacebookShareButton>
                </MenuItem>
                <MenuItem
                    minH="48px"
                    as="div"
                    bg="transparent"
                    p={0}
                    _hover={{ bg: "none" }}
                    display="flex"
                    justifyContent="center"
                >
                  <WhatsappShareButton
                      url={shareUrl} // Use the current page URL
                      title="Check out this event on Eventeam!" // Optional: Add a title for WhatsApp
                  >
                    <WhatsappIcon size={40} round />
                  </WhatsappShareButton>
                </MenuItem>
                <MenuItem
                    minH="48px"
                    as="div"
                    bg="transparent"
                    p={0}
                    _hover={{ bg: "none" }}
                    display="flex"
                    justifyContent="center"
                >
                  <LinkedinShareButton
                      url={shareUrl} // Use the current page URL
                      title="Check out this event on Eventeam!" // Optional: Add a title for LinkedIn
                      summary="Join this amazing event and have fun!" // Optional: Add a summary for LinkedIn
                  >
                    <LinkedinIcon size={40} round />
                  </LinkedinShareButton>
                </MenuItem>
              </VStack>
            </MenuList>
          </Menu>
        </Box>
      </Box>
  );
};
